import { useSelector } from "react-redux";

export default function useMasterGameDefinitions() {
  const masterGameDefinitions = useSelector(
    (state) => state.lobby.masterGameDefinitions
  );

  if (!masterGameDefinitions) {
    console.warn("Missing data at master game definitions");
    return {};
  }

  return masterGameDefinitions;
}
